// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/modelli/:id/anteprima',
    requestBody: null,
    response: '{"success":true,"data":{"modello":"object","tema":"object"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId/anteprima',
    requestBody: null,
    response: '{"success":true,"data":{"modello":"object","tema":"object","dati":"object"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
